import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox-input-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-input-mark" }, null, -1)

import { PropType, ref, watch } from "vue";
import { Uuid } from "@/code/Uuid";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCheckboxInput',
  props: {
  name: String,
  value: String,
  placeholder: String,
  disabled: Boolean,
  label: {
    type: String,
    required: false,
  },
  rules: {
    type: Object as PropType<object | string>,
    required: false,
  },
  id: {
    type: String,
    required: false,
    default: Uuid.newUuid(),
  },
  modelValue: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["update:modelValue", "blur", "focus"],
  setup(__props, { emit }) {

const props = __props;


const model = ref<boolean>(props.modelValue);

const id = ref<string>(props.id);
const onInput = (event: Event) => {
  const targetEl = event.target as HTMLInputElement;
  emit("update:modelValue", targetEl.checked);
};
const onFocus = (event: Event) => {
  emit("focus", (event.target as HTMLInputElement).value);
};
const onBlur = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  emit("blur", value);
};
watch(model, (currVal) => {
  emit("update:modelValue", !!currVal);
});

return (_ctx: any,_cache: any) => {
  const _component_v_field = _resolveComponent("v-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_field, {
      id: id.value,
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      disabled: __props.disabled,
      label: __props.label,
      name: __props.name,
      rules: __props.rules,
      validateOnBlur: true,
      validateOnChange: false,
      validateOnInput: false,
      validateOnModelUpdate: false,
      class: "checkbox-input",
      type: "checkbox",
      "unchecked-label": "",
      value: "on",
      onBlur: onBlur,
      onChange: onInput,
      onFocus: onFocus
    }, null, 8, ["id", "modelValue", "disabled", "label", "name", "rules"]),
    _hoisted_2
  ]))
}
}

})